import React from 'react';
import { useApp } from '../context/AppContext';

const COLORS = {
  ok:   { bg:'rgba(46,204,113,.15)',  border:'rgba(46,204,113,.35)',  color:'#2ecc71' },
  warn: { bg:'rgba(243,156,18,.15)',  border:'rgba(243,156,18,.35)',  color:'#f39c12' },
  err:  { bg:'rgba(231,76,60,.15)',   border:'rgba(231,76,60,.35)',   color:'#e74c3c' },
};

export default function Notification() {
  const { notification: n } = useApp();
  if (!n) return null;
  const c = COLORS[n.type] || COLORS.ok;
  return (
    <div style={{
      position:'fixed', top:12, left:'50%',
      transform:'translateX(-50%)',
      background: c.bg, border:`1px solid ${c.border}`, color: c.color,
      borderRadius:24, padding:'8px 20px',
      fontSize:13, fontWeight:600, zIndex:9999,
      whiteSpace:'nowrap', maxWidth:'90vw',
      overflow:'hidden', textOverflow:'ellipsis',
      animation:'notifIn .25s ease',
      backdropFilter:'blur(8px)',
      pointerEvents:'none',
    }}>
      {n.msg}
    </div>
  );
}
